import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Only attach school header when we're actually inside a school
    const activeSchoolId = localStorage.getItem('active_school_id');
    const isSuper = localStorage.getItem('is_super_admin') === 'true';
    const onPicker = isSuper && !activeSchoolId;

    if (activeSchoolId && !onPicker) {
      config.headers['X-School-Id'] = activeSchoolId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const url = error.config?.url || '';

      // Don't redirect on login attempts or master-token calls
      const skipRedirect =
        url.includes('/auth/token') ||
        url.includes('/super-admin/token') ||
        url.includes('/super-admin/schools');

      if (!skipRedirect) {
        const isSuper = localStorage.getItem('is_super_admin') === 'true';
        if (!isSuper) {
          localStorage.removeItem('token');
          if (api.defaults.headers.common) {
            delete api.defaults.headers.common['Authorization'];
          }
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;